import locator from '@/service-locator'
const LATEST_DATA = 'tamara-latest-data'
const SESSION_DATA = 'tamara-session-data'
const TAMARA_PLATFORM = 'tamara-platform'
const ID_NUMBER = 'tamara-customer-id-number'
const VIEWED_PAYMENT_LINK_LANDING_PAGE =
  'tamara-viewed-payment-link-landing-page'
const CHECKOUT_CONFIGURATION = 'tamara-checkout-configuration'
const CHECKOUT_SUBMIT_PAYLOAD = 'tamara-checkout-submit-payload'
const FAIL_REDIRECTION_FROM_3DS = 'tamara-fail-redirection-from-3ds'

const setLatestData = (data) => {
  window.storage.setItem(LATEST_DATA, JSON.stringify(data))
}

const getLatestData = () => {
  try {
    const latestData = window.storage.getItem(LATEST_DATA)

    return JSON.parse(latestData)
  } catch (_) {
    return {}
  }
}

const clearLatestData = () => {
  window.storage.removeItem(LATEST_DATA)
}

const setSessionData = (data) => {
  window.storage.setItem(SESSION_DATA, JSON.stringify(data))
}

const sessionKey = (key) => {
  const sessionId = locator.store.getters['session/checkoutId'] ?? ''

  if (sessionId === '')
    throw new Error('Failed to get session key for storage.')

  return `tamara-session-${sessionId}-${key}`
}

const getSessionKey = (key, fallback) => {
  try {
    return window?.storage?.getItem(sessionKey(key)) ?? fallback
  } catch (err) {
    return fallback
  }
}

const setSessionKey = (key, value) => {
  window?.storage?.setItem(sessionKey(key), value)
}

const getSessionData = () => {
  try {
    const SessionData = window.storage.getItem(SESSION_DATA)

    return JSON.parse(SessionData)
  } catch (_) {
    console.error(_)
    return {}
  }
}

const clearSessionData = () => {
  window.storage.removeItem(SESSION_DATA)
}

const setPlatform = (value) => {
  window.storage.setItem(TAMARA_PLATFORM, value)
}

const getPlatform = () => {
  try {
    const platform = window.storage.getItem(TAMARA_PLATFORM)

    return platform
  } catch (_) {
    return ''
  }
}

const clearPlatform = () => {
  window.storage.removeItem(TAMARA_PLATFORM)
}

const setIdNumber = (value) => {
  window.storage.setItem(ID_NUMBER, value)
}

const getIdNumber = () => {
  try {
    return window.storage.getItem(ID_NUMBER)
  } catch (_) {
    return ''
  }
}

const clearIdNumber = () => {
  window.storage.removeItem(ID_NUMBER)
}

const setViewedPaymentLinkLandingPage = (data) => {
  window.storage.setItem(VIEWED_PAYMENT_LINK_LANDING_PAGE, JSON.stringify(data))
}

const getViewedPaymentLinkLandingPage = () => {
  try {
    const cachedData = window.storage.getItem(VIEWED_PAYMENT_LINK_LANDING_PAGE)

    if (!cachedData) {
      return {}
    }

    return JSON.parse(cachedData)
  } catch (_) {
    return {}
  }
}

const clearViewedPaymentLinkLandingPage = () => {
  window.storage.removeItem(VIEWED_PAYMENT_LINK_LANDING_PAGE)
}

const setConfiguration = (configurations) => {
  window.storage.setItem(CHECKOUT_CONFIGURATION, JSON.stringify(configurations))
}

const getConfiguration = (configurations) => {
  try {
    const cachedData = window.storage.getItem(CHECKOUT_CONFIGURATION)

    if (!cachedData) {
      return {}
    }

    return JSON.parse(cachedData)
  } catch (_) {
    return {}
  }
}

const removeConfiguration = () => {
  window.storage.removeItem(CHECKOUT_CONFIGURATION)
}

const setSubmitPayload = (payload) => {
  window.storage.setItem(CHECKOUT_SUBMIT_PAYLOAD, JSON.stringify(payload))
}

const getSubmitPayload = () => {
  try {
    const cachedData = window.storage.getItem(CHECKOUT_SUBMIT_PAYLOAD)

    if (!cachedData) {
      return {}
    }

    return JSON.parse(cachedData)
  } catch (_) {
    return {}
  }
}

const setCko3dsStatus = (status = false) => {
  window.storage.setItem(FAIL_REDIRECTION_FROM_3DS, status)
}

const getCko3dsStatus = () => {
  try {
    const cachedData = window.storage.getItem(FAIL_REDIRECTION_FROM_3DS)

    if (!cachedData) {
      return false
    }

    return cachedData === 'true'
  } catch (_) {
    return false
  }
}

const removeCko3dsStatus = () => {
  window.storage.removeItem(FAIL_REDIRECTION_FROM_3DS)
}

export default {
  // latest order
  setLatestData,
  getLatestData,
  clearLatestData,
  // latest session
  setSessionData,
  getSessionData,
  clearSessionData,
  // Platform
  setPlatform,
  getPlatform,
  clearPlatform,
  // ID number - verify with ELM
  setIdNumber,
  getIdNumber,
  clearIdNumber,
  // Flag view landing page
  setViewedPaymentLinkLandingPage,
  getViewedPaymentLinkLandingPage,
  clearViewedPaymentLinkLandingPage,
  // Configurations
  setConfiguration,
  getConfiguration,
  removeConfiguration,
  // Save payload
  setSubmitPayload,
  getSubmitPayload,
  // 3DS status cache
  setCko3dsStatus,
  getCko3dsStatus,
  removeCko3dsStatus,
  getSessionKey,
  setSessionKey,
}
